export default __webpack_public_path__ + "media/happy_mobile.74b64785.png";